require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-jquery-target-the-parent-of-an-element-using-jquery.json") })
        }
      }, "path---front-end-libraries-jquery-target-the-parent-of-an-element-using-jquery");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-jquery-target-the-parent-of-an-element-using-jquery!./.cache/json/front-end-libraries-jquery-target-the-parent-of-an-element-using-jquery.json
// module id = 2047
// module chunks = 231608221292675